import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import Hero2 from '../../components/hero2'
// import Service from '../../components/Service'
import AboutS2 from '../../components/AboutS2'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.png'
// import FunFact from "../../components/FunFact";
import PartnerSection from '../../components/PartnerSection';
import Testimonial from '../../components/Testimonial';
// import TeamSection from '../../components/TeamSection'


const HomePage =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo} hclass={'wpo-header-style-2'}/>
            <Hero2/>
            <AboutS2/>
            {/* <Service Fclass={'wpo-features-section-s2'}/> */}
            {/* <FunFact/> */}
            <Testimonial/>
            {/*<CauseSection/>*/}
            {/*<ProjectSection/>*/}
            {/*<EventSection/>*/}
            {/*<BlogSection/>*/}
            <PartnerSection/>
            {/* <TeamSection/> */}
            <Scrollbar/>
            <Footer/>
        </Fragment>
    )
};
export default HomePage;